/**
 * Copyright (c) 2021-22 Amway
 * @author Charu Agrawal
 */

import React from "react";
import i18n from "../../../i18n";

//interface for ToggleButton Props
interface ToggleButtonProps {
  handleOnClickToggle?: (type1: string, type2: string) => void;
  handleOnClickToggle2?: (type: boolean) => void;
  handleOnKyPressToggle2?: (type: string, e: any) => void;
  t?: any;
  lableLeft: string;
  lableRight: string;
  type1?: any;
  type2?: any;
  isChecked?: any;
}

interface ToggleButtonState {
  isChecked: boolean;
}

/**
 * Reusable React component - ToggleButton.
 *
 * @namespace ToggleButton
 */
class ToggleButton extends React.Component<
  ToggleButtonProps,
  ToggleButtonState
> {
  constructor(props: ToggleButtonProps) {
    super(props);
    this.state = {
      isChecked: this.props.isChecked && this.props.isChecked,
    };
  }

  componentDidMount=()=>{
    if (this.props.handleOnClickToggle2) {

    
      this.props.handleOnClickToggle2(true);
    }
  }

  render() {
    const { lableLeft, lableRight } = this.props;
    return (
      <>
        <label className="switch">
          <input type="checkbox" checked={this.state.isChecked} />
          {/* toggle container */}
          <div className="slider toggle-container">
            {/* left-box container starts here */}
            <div
              tabIndex={0}
              role="button"
              aria-pressed={this.state.isChecked}
              className="left-box-container"
              onClick={() => {
                this.setState({
                  isChecked: !this.state.isChecked,
                });
                this.props.handleOnClickToggle2 &&
                  //this.props.handleOnClickToggle("cm", "kg");
                  this.props.handleOnClickToggle2(this.state.isChecked);
              }}
              onKeyPress={(e: any) => {
                this.setState({
                  isChecked: !this.state.isChecked,
                });
                this.props.handleOnKyPressToggle2 &&
                  //this.props.handleOnClickToggle("cm", "kg");
                  this.props.handleOnKyPressToggle2(this.props.type2, e);
              }}
            >
              {/* {this.props.t("common.centimeter_and_kilogram_unit_label")} */}
              {lableLeft}
            </div>
            {/* left-box container ends here */}
            {/* right-box container starts here */}
            <div
              tabIndex={0}
              role="button"
              aria-pressed={this.state.isChecked}
              className="right-box-container"
              onClick={() => {
                this.setState({
                  isChecked: !this.state.isChecked,
                });

                //this.props && this.props.handleOnClickToggle("ft", "lbs");
                this.props.handleOnClickToggle2 &&
                  this.props.handleOnClickToggle2(this.state.isChecked);
              }}
              onKeyPress={(e: any) => {
                this.setState({
                  isChecked: !this.state.isChecked,
                });
                this.props.handleOnKyPressToggle2 &&
                  //this.props.handleOnClickToggle("cm", "kg");
                  this.props.handleOnKyPressToggle2(this.props.type1, e);
              }}
            >
              {/* {this.props.t("common.centimeter_and_kilogram_unit_label")} */}
              {lableRight}
            </div>
            {/* right-box container ends here */}
          </div>
        </label>
      </>
    );
  }
}

export default ToggleButton;
